module.exports = __webpack_public_path__ + "img/icon-checkmark-blue.161fb984.svg";